import React, { useState, useEffect } from 'react';
import { Container, Paper, TextField, Button, Box, FormControlLabel, Checkbox, MenuItem, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api/axiosConfig';

const DepartamentoForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const user = localStorage.getItem('user');

  const [formData, setFormData] = useState({
    id_sector: '',
    id_programa: '',
    id_proyecto: '',
    codigo: '',
    descripcion: '',
    responsable: '',
    observaciones: '',
    activo: true,
  });
  const [sectores, setSectores] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/sectores/').then(res => setSectores(res.data));
  }, []);

  useEffect(() => {
    if (formData.id_sector) {
      api.get(`/programas/?id_sector=${formData.id_sector}`).then(res => setProgramas(res.data));
    } else {
      setProgramas([]);
    }
  }, [formData.id_sector]);

  useEffect(() => {
    if (formData.id_programa) {
      api.get(`/proyectos/?id_programa=${formData.id_programa}`).then(res => setProyectos(res.data));
    } else {
      setProyectos([]);
    }
  }, [formData.id_programa]);

  useEffect(() => {
    if (id) {
      api.get(`/departamentos/${id}/`).then(res => setFormData(res.data));
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      ...formData,
      creado_por: user,
      modificado_por: user,
    };

    try {
      if (id) {
        await api.put(`/departamentos/${id}/`, { ...formData, modificado_por: user });
      } else {
        await api.post('/departamentos/', payload);
      }
      navigate('/departamentos');
    } catch (err) {
      setError('Error al guardar el departamento');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            select
            label="Sector *"
            fullWidth
            value={formData.id_sector}
            onChange={(e) => setFormData({ ...formData, id_sector: e.target.value, id_programa: '', id_proyecto: '' })}
            margin="normal"
            required
          >
            {sectores.map(sec => (
              <MenuItem key={sec.id_sector} value={sec.id_sector}>
                {sec.codigo} - {sec.descripcion}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Programa *"
            fullWidth
            value={formData.id_programa}
            onChange={(e) => setFormData({ ...formData, id_programa: e.target.value, id_proyecto: '' })}
            margin="normal"
            required
            disabled={!formData.id_sector}
          >
            {programas.map(prog => (
              <MenuItem key={prog.id_programa} value={prog.id_programa}>
                {prog.codigo} - {prog.descripcion}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Proyecto *"
            fullWidth
            value={formData.id_proyecto}
            onChange={(e) => setFormData({ ...formData, id_proyecto: e.target.value })}
            margin="normal"
            required
            disabled={!formData.id_programa}
          >
            {proyectos.map(proy => (
              <MenuItem key={proy.id_proyecto} value={proy.id_proyecto}>
                {proy.codigo} - {proy.descripcion}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Código *"
            fullWidth
            value={formData.codigo}
            onChange={(e) => setFormData({ ...formData, codigo: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Descripción *"
            fullWidth
            value={formData.descripcion}
            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Responsable *"
            fullWidth
            value={formData.responsable}
            onChange={(e) => setFormData({ ...formData, responsable: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            label="Observaciones"
            fullWidth
            multiline
            rows={3}
            value={formData.observaciones}
            onChange={(e) => setFormData({ ...formData, observaciones: e.target.value })}
            margin="normal"
          />
          <FormControlLabel
            control={<Checkbox checked={formData.activo} onChange={(e) => setFormData({ ...formData, activo: e.target.checked })} />}
            label="Activo"
          />
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Box sx={{ mt: 2 }}>
            <Button type="submit" variant="contained" disabled={loading} sx={{ mr: 1 }}>
              {loading ? 'Guardando...' : id ? 'Actualizar' : 'Crear'}
            </Button>
            <Button onClick={() => navigate('/departamentos')}>Cancelar</Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default DepartamentoForm;